import { render, staticRenderFns } from "./FuseSelectPage.vue?vue&type=template&id=21b45973&scoped=true"
import script from "./FuseSelectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FuseSelectPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b45973",
  null
  
)

export default component.exports